<template>
  <router-link v-bind="props" :to="to">
    <template v-for="(_, slotName) in slots" v-slot:[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps ?? {}" />
    </template>
  </router-link>
</template>

<script setup lang="ts">
import { RouterLink, type RouterLinkProps } from 'vue-router';
import { computed } from 'vue';
import { useActiveSeason } from '@/store/active-season.ts';

const slots = defineSlots();

const props = defineProps<RouterLinkProps>();
const to = computed(() => useActiveSeason().rewriteRouteLocation(props.to));
</script>

<style scoped lang="scss">
@use 'sass:math';
@import '@styles/variables';
</style>
